export default function CollabChip({
  label,
  icon,
  selected = false,
  onClick,
}: {
  label: string;
  icon?: string | null;
  selected?: boolean;
  onClick?: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full border px-3 py-1.5 text-sm transition ${
        selected
          ? 'border-transparent bg-mlbb-accent text-white'
          : 'border-mlbb-border bg-mlbb-card text-white/80 active:bg-mlbb-border'
      }`}
    >
      {icon && <img src={icon} alt="" className="h-4 w-4 rounded-sm object-contain" />}
      {label}
    </button>
  );
}
